<template>
  <modal
      id="crm-list-modal"
      size="large"
      v-model="showModal"
      :title="from === 'user' ? generateModalTitle('user') : generateModalTitle('Loyalty Reward')"
      @submit="submit"
      :loading="loading"
      :btn-label="selectedUrl ? $t('save') : $t('add')"
      :preloader="preloader">

    <form
        v-if="(isMailSettingExist || selectedUrl) && !preloader"
        ref="form"
        method="post"
        enctype="multipart/form-data"
        :data-url='selectedUrl ? CRM_LOYALTY_REWARD : CRM_LOYALTY_REWARD'
        @submit.prevent="submitData"
    >

      <div class="row mb-4">
        <div class="col-md-12">
          <app-form-group
              type="text"
              :label="$t('reward_title')"
              v-model="formData.reward_title"
              :error-message="$errorMessage(errors, 'reward_title')"
          />
        </div>
        <div class="col-md-12">
          <app-form-group
              type="text"
              :label="$t('reward_sub_title')"
              v-model="formData.reward_sub_title"
              :error-message="$errorMessage(errors, 'reward_sub_title')"
          />
        </div>
      </div>

<!--      <div class="horizontal_separator" />-->
      <hr class="mb-4">

      <div class="row mb-4"
           v-for="(brand, index) in formData.brands"
           :key="index"
           :id="index"
      >
        <div class="w-100">
          <div class="col-md-12">
            <div class="row d-flex align-items-center">
              <div class="col-md-10">
                <app-form-group
                    :label="`Image`"
                    page="page"
                    :id="`image-${index}`"
                    type="file"
                    v-model="formData.brands[index].image"
                    :error-message="$errorMessage(errors, 'image')"
                    :file-label="$fieldLabel('icon', 'Image')"
                    @change="handleFileChange($event, index)"
                />
<!--                <app-form-group
                    :label="$fieldLabel('icon', 'image')"
                    page="page"
                    type="custom-file-upload"
                    v-if="imageUploaderBoot"
                    v-model="formData.brands[index].image"
                    :error-message="$errorMessage(errors, 'image')"
                    :generate-file-url="false"
                    :recommendation="$t('recommended_app_logo_size')"
                    :file-label="$fieldLabel('icon', 'image')"
                />-->
              </div>
              <div class="col-md-2">
                <i class="fa fa-plus-circle btn-outline-success rounded-pill cursor-pointer p-2" @click="addBrand"></i>
                <i class="fa fa-minus-circle btn-outline-danger rounded-pill cursor-pointer p-2"
                   v-if="formData.brands.length > 1"
                   @click="removeBrand(index)"></i>
              </div>
            </div>
          </div>
          <div class="col-md-12">
            <app-form-group
                type="text"
                :label="$t('title')"
                v-model="brand.title"
                :error-message="$errorMessage(errors, 'title')"
            />
          </div>
          <div class="col-md-12">
            <app-input
                type="textarea"
                v-model="brand.content"
                :text-area-rows="4"
                :error-message="$errorMessage(errors, 'content')"
                :placeholder="$textAreaPlaceHolder('content')"
            />
          </div>
        </div>
      </div>
    </form>

    <template v-if="!isMailSettingExist && !selectedUrl" slot="footer">
      <button type="button"
              class="btn btn-secondary"
              data-dismiss="modal">
        {{ $t('close') }}
      </button>
    </template>
  </modal>
</template>

<script>
import FormHelperMixins from "../../../../common/Mixin/Global/FormHelperMixins";
import ModalMixin from "../../../../common/Mixin/Global/ModalMixin";
import {
  CRM_LOYALTY_REWARD
} from "../../../Config/ApiUrl";
import {
  TENANT_MAIL_CHECK_URL,
} from "../../../../common/Config/apiUrl";
import {axiosGet, axiosPost, urlGenerator} from "../../../../common/Helper/AxiosHelper";
import LogMixin from "../../Mixins/LogMixin";
import {textEditorHints} from "../../../../common/Helper/Support/TextEditorHelper";
import {crmTag} from "../../../../common/Components/Settings/Common/http/NotificationTemplate/Helper";
import TemplateMixins from "../../../../common/Components/Settings/Common/http/NotificationTemplate/TemplateMixins";

export default {
  name: "CRMCreateEditModal",
  mixins: [FormHelperMixins, ModalMixin, LogMixin, TemplateMixins],
  props: {
    from: {
      type: String,
      default: 'brand'
    },
    loaderColor: {
      type: String,
      default: 'white-color'
    }
  },
  data() {
    return {
      textEditorHints,
      tags: crmTag(),
      maps: null,
      isMailSettingExist: true,
      preloader: false,
      loading: false,
      // brands: [
      //   {
      //     title: "",
      //     image: ""
      //   }
      // ],
      imageUploaderBoot: false,
      formData: {
        reward_title: '',
        reward_sub_title: '',
        brands: [
          {
            image: "",
            title: "",
            content: ""
          }
        ]
      },
      CRM_LOYALTY_REWARD,
    }
  },
  methods: {
    handleFileChange(event, index) {
      console.log(index);
      const file = event.target.files[0];
      if (file) {
        this.formData.brands[index].image = file;
      }
      console.log(this.formData.brands);
    },
    async submit() {
      this.fieldStatus.isSubmit = true;
      this.loading = true;
      this.message = '';
      this.errors = {};

      await this.uploadImage(this.formData.brands);
      console.log(this.formData);
      this.submitData(this.formData.brands);
    },
    addBrand() {
      this.formData.brands.push({
        title: "",
        image: ""
      });
      console.log(this.formData.brands);
    },
    removeBrand(index) {
      this.formData.brands.splice(index, 1);
    },
    async uploadImage(brands) {
      // Iterate over each brand to upload the corresponding image
      for (const brand of brands) {
        const file = brand.image; // Access the image file for the current brand
        const formData = new FormData();
        formData.append('image', file);

        try {
          const response = await axios.post('/admin/crm/section/image', formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          });
          // Assuming the response contains the URL of the uploaded image
          brand.image = response.data.url; // Update the brand's image with the uploaded URL
        } catch (error) {
          console.error("There was an error uploading the image", error);
          // You might want to handle the error by storing it in this.errors or a similar structure
        }
      }
    },
    afterSuccess({data}) {
      this.formData = {};
      $('#crm-list-modal').modal('hide');
      this.$emit('input', false);
      this.toastAndReload(data.message, this.from === 'crm' ? 'crm-table' : 'user-table');
      if (this.from === 'user') {
        this.$hub.$emit(`reload-role-table`)
      } else {
        this.$hub.$emit(`reload-crm-table`)
      }
    },
    afterSuccessFromGetEditData({data}) {
      this.formData.brands = [];
      this.preloader = false;
      // let heading = data.reward_heading;
      let [heading] = data;
      data.splice(0, 1);
      console.log(data, heading);
      // delete data.reward_heading;
      // console.log(Object.entries(data).length);
      this.formData.reward_title = heading.reward_title;
      this.formData.reward_sub_title = heading.reward_sub_title;

      // Extracting and formatting the data
      if (data.length) {
        data.map((d, index) => {
          this.formData.brands.push({
            title: d.title,
            image: d.image,
            content: d.content
          });
        });
      }
      else {
        this.formData.brands.push({
          title: "",
          image: "",
          content: ""
        });
      }

    },
    generateModalTitle(subject) {
      return this.$fieldTitle(this.selectedUrl ? 'edit' : 'edit', subject, true);
    },
  },
  created() {
  },
  computed: {},
  mounted() {
  },
}
</script>